import { useSchemeAddonQuery } from '~/gql/generated/graphql'

export const useSchemeAddon = ({ schemeAddonId }) => {
  const { data, ...rest } = useSchemeAddonQuery({
    variables: { schemeAddonId },
    pollInterval: 0,
    errorPolicy: 'all',
  })

  // Extract price.amount to populate form values
  const initialValues = data?.scheme_addon
    ? {
        ...data?.scheme_addon,
        amount: data?.scheme_addon?.price.amount,
        // Map this different field name, validity_interval on the input expects a string
        // but we're now using the enum value.
        validity: data?.scheme_addon?.validity_interval,
      }
    : undefined

  return {
    ...rest,
    data,
    initialValues,
  }
}
